export default {
  isEven(n) {
    return n == parseFloat(n) && !(n % 2);
  },
  isOdd(n) {
    return n == parseFloat(n) && !!(n % 2);
  },
  hideAllInArr(arr) {
    arr.forEach(($elem) => {
      $elem.hide();
    });
  },
  showAllInArr(arr) {
    arr.forEach(($elem) => {
      $elem.show();
    });
  }
}
